export default __webpack_public_path__ + "static/media/client_logos_mobile.d0b3545c.png";